import {  CreateResponsiveStyle,  DEVICE_SIZES,  maxSize,} from "rn-responsive-styles";
import { COLORS, FONTS } from "../../constant";


const useStyles = CreateResponsiveStyle(
    {
        container: {
            backgroundColor: '#fff',
            borderRadius: 11,
            marginLeft: 0,
            minHeight: 333
        },
        footerBtnWrapper:{ 
            width: 123.5,
             height: 36, 
             alignSelf: "center",  
             marginTop: 20,
         },
        contentWidget: {
            paddingLeft: 70,
            paddingBottom: 40
        },
        navWidget: {
            flexDirection: "row", 
            justifyContent: 'space-between',
            marginTop:20,
            alignItems:'center'
        },
        navWidgetInner:{ marginLeft: 30 },
        scrollViewStyle: {
            marginBottom: -30,
            marginLeft: -10,
        },
        flatListStyle: {
            height: 200,
            paddingBottom: 20,
            marginTop: 20,
        },
        viewStyle: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 10,
            paddingRight: 10,
            marginRight: 10,
            marginBottom: 5,
            width: 300,
            height: 99,
            borderWidth: 1,
            borderColor: COLORS.boderColor,
            borderRadius: 10
        },
        searchWidget: {
            alignSelf: 'flex-end',
            minWidth: 240,
            marginRight: 60,
            marginTop: 15,
            alignItems: 'center'
        },
        searchIconContainerStyle: {
            position: "absolute",
            zIndex: 999,
            right: 24,
            top: 20
        },
        radiobuttonOutSideStyle: {
            width: 15,
            height: 15,
            borderRadius: 10,
            borderColor: "#9d1d27",
            borderWidth: 2,
            alignItems: "center",
            justifyContent: "center",
            marginLeft: 10,
        },
        lowBalanceText: {
            fontSize: 11,
            color: COLORS.red,
            fontWeight: "bold",
            marginLeft: 3,
        },
        overlayViewStyle: {
            position: "absolute",
            zIndex: 9999,
            backgroundColor: "rgba(52,52,52,0.9)",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            borderRadius: 15,
        },
        overlayContainer: {
            width: "100%",
            height: "100%",
            zIndex: 99999,
            alignItems: "center",
            justifyContent: "center",
        },
        overlay: {
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
        },
        overlayContentViewStyle: {
            width: 348,
            height: 270,
            borderRadius: 13,
            backgroundColor: "#ffffff",
            shadowColor: "rgba(0, 0, 0, 0.05)",
            shadowOffset: {
                width: 0,
                height: 27,
            },
            shadowRadius: 34,
            shadowOpacity: 1,
        },
        resendViewStyle: {
            flexDirection: "row",
            justifyContent: "space-between",
            marginHorizontal: "15%",
        },
        proceedBtnDT:{ 
            width: 200,  
            marginRight: 20 
        },
        proceedBtnMobile:{
            display:'none'
        }

    },


    {
        [DEVICE_SIZES.LG]: {
        },

        [DEVICE_SIZES.MD]: {
        },

        [maxSize(DEVICE_SIZES.SM)]: {
            dashboard_headerCards_layoutBoxes: {
                width: "100%",
            },
            navWidget: {
                flexDirection: 'column'
            },
            navWidgetInner:{ marginLeft: 15 },
            proceedBtnMobile:{
                display:'flex',
                width: 200,  
                alignSelf:'center',
                marginVertical:30
            }
        },

        [DEVICE_SIZES.SM]: {
            container: {
                marginLeft: 0
            },
            contentWidget: {
                paddingLeft: 20,
                paddingBottom: 60
            },
            overlayViewStyle: {
                left: 0
            },
            navWidgetInner:{ marginLeft: 10 },
            proceedBtnMobile:{
                display:'flex',
                width: 200,  
                alignSelf:'center',
                marginVertical:30
            },
            proceedBtnDT:{
                display:'none'
            }
        },
        [DEVICE_SIZES.XS]: {
           
            container: {
                marginLeft: 10
            },
            navWidget: {
                flexDirection: 'column',
                justifyContent:'center'
            },
            navWidgetInner:{ marginLeft: 10 },
            contentWidget: {
                paddingLeft: 20,
                paddingBottom: 70,
                marginBottom: 30
            },
            overlayViewStyle: {
                left: 0
            },
            proceedBtnDT:{
                display:'none'
            },
            proceedBtnMobile:{
                display:'flex',
                width: 200,  
                alignSelf:'center',
                marginVertical:30
            },
            viewStyle: {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                paddingLeft: 10,
                paddingRight: 10,
                marginRight: 10,
                marginBottom: 5,
                width: 250,
                height: 99,
                borderWidth: 1,
                borderColor: COLORS.boderColor,
                borderRadius: 10
            },
            searchWidget: {
                alignSelf: 'center',
                minWidth: 240,
                marginRight: 60,
                marginTop: 15,
                alignItems: 'center'
            },

        },
    }
);
export default useStyles;
